<template>  
    <section>
        <componet :is="sign"></componet>
		<div class="tabs sale">
			<span :class='mark==1?"order-select":"order"' 	@click='change(1)'>订单</span>
			<span :class='mark==2?"person-select":"person"'	@click='change(2)'>我的</span>
		</div>

    </section>
</template>

<script>
    import CommonHeader from '@/components/CommonHeader'
	import OrderSale from '@/components/MyOrderSale'
	import PersonSale from '@/components/PersonalSale'
    import utils from '@/assets/jslibs/utils'
    export default {
        name: 'index',
		data(){
			return{
                imgUrl:this.$store.state.imgUrl || sessionStorage.getItem("imgUrl"),
				mark:sessionStorage.getItem("mark")|| 1,
				sign:sessionStorage.getItem("sign") || "order-sale"
			}
		},
        
        components: {
            CommonHeader,
			OrderSale,
			PersonSale
        },
        
        beforeRouteLeave(to, from, next) {
            // 设置下一个路由的 meta
            from.meta.keepAlive = true; // 让 A 缓存，即不刷新
            next();
        },
		
		beforeCreate(){
			sessionStorage.removeItem("roleType");
		},
		
        methods:{
            change(type){
                if(type == 1){
                    this.mark=1;
                    this.sign="order-sale"
                    sessionStorage.setItem("mark",1);
                    sessionStorage.setItem("sign","order-sale");
                    document.title = "我的订单"
                }else{
                    this.mark = 2;
                    this.sign="person-sale";
                    sessionStorage.setItem("mark",2);
                    sessionStorage.setItem("sign","person-sale");
                    document.title = "个人中心"
                    
                }
            }
        }
    }
</script>

<style lang='less' scoped>
	@import '~@/assets/styles/variable.less';
	@import '~@/assets/styles/handleMethods.less';
	@import '~@/assets/styles/reset.css';
    section{font-family:PingFangSC-Regular;;font-weight:400;background: #fff;/* padding-bottom: 80px */}
	.list{overflow-y: scroll; width: 100%;height: 100%;}
	.tabs{width: 100%;position: fixed;bottom: 0;left: 0;right: 0;padding: 0 63px;padding-top: 6px;display: -webkit-box;display: -ms-flexbox;display: flex;justify-content: space-between;align-items: center;background: #fff}
	.tabs span{font-size: 12px;padding-top:25px;text-align: center;}
    .home{color:rgba(51,51,51,1);background:url(../assets/images/home/ic_home_home_formal.png) no-repeat center top;background-size: 22px}
	.order{color:rgba(51,51,51,1);background:url(../assets/images/home/ic_home_order_form.png) no-repeat center top;background-size: 22px}
	.person{color:rgba(51,51,51,1);background:url(../assets/images/home/ic_home_mine_formal.png) no-repeat center top;background-size: 22px}
	.home-select{color: #4184F4;background:url(../assets/images/home/ic_home_home_light.png) no-repeat center top;background-size: 22px}
	.order-select{color: #4184F4;background:url(../assets/images/home/ic_home_order_light.png) no-repeat center top;background-size: 22px}
	.person-select{color: #4184F4;background:url(../assets/images/home/ic_home_mine_light.png) no-repeat center top;background-size: 22px}
</style>
